var NavMobile = /** @class */ (function () {
    function NavMobile(headerElement, navigationHolderElement) {
        this.exists = false;
        this.isVisible = false;
        // class to select the parent pages - the ones that we interact with the most.
        this.parentPagesClass = 'ul.main-navigation-mobile > li.menu-item-has-children';
        this.header = headerElement;
        this.navTrigger = this.header.find('.btn-toggle-nav');
        this.navigationHolder = navigationHolderElement;
        this.parentPages = this.navigationHolder.find(this.parentPagesClass);
    }
    /**
     * init the navigation
     */
    NavMobile.prototype.init = function () {
        var _this = this;
        if (!this.exists) {
            this.exists = true;
            this.parentPages.find('>.sub-menu').slideUp(0);
            this.parentPages.find('>a').on('click', this.toggleSubmenuViaClick = function (e) {
                _this.toggleSubmenu(e);
            });
            // toggle the navigation on trigger click
            this.navTrigger.on('click', this.toggleNavViaClick = function () {
                if (!_this.isVisible) {
                    _this.showNavigation();
                }
                else {
                    _this.hideNavigation();
                }
            });
            // hide the nav on escape button
            jQuery(document).on('keyup', this.closeNavViaEscape = function (e) {
                if (e.key === 'Escape') {
                    _this.hideNavigation();
                }
            });
        }
    };
    /**
     * destroy this navigation
     */
    NavMobile.prototype.destroy = function () {
        if (this.exists) {
            this.exists = false;
            // reset the nav
            this.isVisible = false;
            this.navTrigger.removeClass('active');
            this.navigationHolder.removeClass('visible active');
            clearTimeout(this.hideNavigationTimer);
            // remove some event listeners
            this.parentPages.find('>a').off('click', this.toggleSubmenuViaClick);
            this.navTrigger.off('click', this.toggleNavViaClick);
            jQuery(document).off('keyup', this.closeNavViaEscape);
        }
    };
    /**
     * show the navigation
     */
    NavMobile.prototype.showNavigation = function () {
        var _this = this;
        clearTimeout(this.hideNavigationTimer);
        this.isVisible = true;
        this.navTrigger.addClass('active');
        this.navigationHolder.addClass('active');
        this.header.addClass('nav-open');
        window.BCB.nextTick(function () { _this.navigationHolder.addClass('visible'); });
    };
    /**
     * hide the navigation
     */
    NavMobile.prototype.hideNavigation = function () {
        var _this = this;
        this.isVisible = false;
        this.navTrigger.removeClass('active');
        this.navigationHolder.removeClass('visible');
        this.hideNavigationTimer = setTimeout(function () {
            _this.navigationHolder.removeClass('active');
            _this.header.removeClass('nav-open');
        }, 350);
    };
    /**
     * toggle a submenu
     */
    NavMobile.prototype.toggleSubmenu = function (e) {
        // stop link from redirection
        e.preventDefault();
        // find the corresponding parent
        var targetMenu = jQuery(e.target).parents(this.parentPagesClass);
        // and toggle it
        targetMenu.toggleClass('open-sub-menu');
        targetMenu.find('>.sub-menu').slideToggle(300);
    };
    return NavMobile;
}());
export { NavMobile };
